import { render, staticRenderFns } from "./MessageTypeSystemReply.vue?vue&type=template&id=6259d5b3&scoped=true&"
import script from "./MessageTypeSystemReply.vue?vue&type=script&lang=ts&"
export * from "./MessageTypeSystemReply.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTypeSystemReply.vue?vue&type=style&index=0&id=6259d5b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6259d5b3",
  null
  
)

export default component.exports